import { network } from 'services/network';

export const getBoardTaskInit = (params) => {
    const url = `api/bo/getBoardTaskInit?wbsId=${params.wbsId}`;

    return network.get(url).then((response) => {
        return response.data.activitiesList;
    });
};
